import React, { useState } from "react";
import { translate } from "../Services/translation";

const NotifyButton = ({ productId, addStockNotify, isStockNotify }) => {
  const [showStockNotify, setStockNotify] = useState(isStockNotify);
  const handleStockNotify = (productId) => {
    setStockNotify(!showStockNotify);
    addStockNotify(productId);
  };
  
  return (
    <div>
      <a className="stock__subscribe" onClick={() => handleStockNotify(productId)}>
        {translate(showStockNotify ? "product.stock.notify.subscribe" : "product.stock.notify.notsubscribed")}
      </a>
    </div>
  );
};

export default NotifyButton;
